const actionTypes = {
  addDetails: 'PATIENT_DETAILS_ADD_DETAILS',
  changePhone: 'PATIENT_DETAILS_CHANGE_PHONE',
  clearDetails: 'PATIENT_DETAILS_CLEAR_DETAILS',
  fetchPatientDetailForSmokingAppointment:
    'FETCH_PATIENT_DETAIL_FOR_SMOKING_APPOINTMENT',
  isReady: 'PATIENT_DETAILS_IS_READY',
};

const fetchPatientDetailForSmokingAppointment = () => ({
  type: actionTypes.fetchPatientDetailForSmokingAppointment,
});
const isReady = () => ({
  type: actionTypes.isReady,
});
const addDetails = details => ({
  type: actionTypes.addDetails,
  payload: { details },
});
const changePhone = mobile => ({
  type: actionTypes.changePhone,
  payload: { mobile },
});
const clearDetails = () => ({
  type: actionTypes.clearDetails,
});

const actions = {
  addDetails,
  changePhone,
  clearDetails,
  fetchPatientDetailForSmokingAppointment,
  isReady,
};

export { actionTypes, actions };
